import {
  QUERIES,
  WithChildren,
  createResponseContext,
  initialQueryResponse,
  stringifyRequestQuery,
} from '../../../../../../_metronic/helpers'
import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'

import { ImportacaoErro } from './_models'
import { getErrosImportacoes } from './_requests'
import { useParams } from 'react-router-dom'
import { useQueryRequest } from './QueryRequestProvider'
import { useModal } from '../../../../../components'

const QueryResponseContext = createResponseContext<ImportacaoErro>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const { id } = useParams()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.IMPORTACOES_ERROS_LIST, id, query, isOpen],
    () => getErrosImportacoes(Number(id), query),
    { cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false, enabled: !isOpen }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
